import { urls } from '../../../config/urls'

const IS_HCA_ENABLED = process.env.GATSBY_IS_HCA_ENABLED === 'true'

const quizData = {
  description: 'Quiz to help with student placement',
  id: 'uma-quiz-01',
  initialNode: 'uma-01',
  title: 'UMA Program Quiz',
  // HCA Enabled tree. This tree is used when IS_HCA_ENABLED is true
  hcaTree: {
    id: 'uma-01',
    children: [
      {
        id: 'uma-online-01',
        children: [
          {
            id: 'uma-online-02',
            children: [
              {
                id: 'uma-online-03',
                children: [
                  { id: 'uma-online-05' },
                  {
                    id: 'uma-online-06',
                    children: [
                      { id: 'uma-online-07' },
                      { id: 'uma-online-08' },
                    ],
                  },
                ],
              },
              { id: 'uma-online-04', children: [{ id: 'uma-online-14' }, { id: 'uma-online-15' }] },
            ],
          },
          {
            id: 'uma-online-09',
            children: [
              {
                id: 'uma-online-10',
                children: [{ id: 'uma-online-12' }, { id: 'uma-online-13' }],
              },
              { id: 'uma-online-11' },
            ],
          },
        ],
      },
      {
        id: 'uma-ground-01',
        children: [
          { id: 'uma-ground-03' },
          {
            id: 'uma-ground-02',
            children: [
              { id: 'uma-ground-04' },
              { id: 'uma-ground-05' },
              { id: 'uma-ground-06' },
              { id: 'uma-ground-07' },
            ],
          },
        ],
      },
    ],
  },
  // Default tree
  tree: {
    id: 'uma-01',
    children: [
      {
        id: 'uma-online-01',
        children: [
          {
            id: 'uma-online-02',
            children: [
              {
                id: 'uma-online-03',
                children: [
                  { id: 'uma-online-05' },
                  {
                    id: 'uma-online-06',
                    children: [
                      { id: 'uma-online-07' },
                      { id: 'uma-online-08' },
                    ],
                  },
                ],
              },
              { id: 'uma-online-04' },
            ],
          },
          {
            id: 'uma-online-09',
            children: [
              {
                id: 'uma-online-10',
                children: [{ id: 'uma-online-12' }, { id: 'uma-online-13' }],
              },
              { id: 'uma-online-11' },
            ],
          },
        ],
      },
      {
        id: 'uma-ground-01',
        children: [
          { id: 'uma-ground-03' },
          {
            id: 'uma-ground-02',
            children: [
              { id: 'uma-ground-04' },
              { id: 'uma-ground-05' },
              { id: 'uma-ground-06' },
              { id: 'uma-ground-07' },
            ],
          },
        ],
      },
    ],
  },
}

/**
 * Note that answers on a node are the answer to the previous question
 */
const groundNodes = {
  'uma-ground-01': {
    asksQuestion:
      'Do you think your ideal workplace setting would be in a dental or medical setting?',
    providesAnswer: 'Yes, I can commute to Clearwater, FL.',
    programs: ['UNSPEC'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Clearwater.jpg`,
  },
  'uma-ground-02': {
    asksQuestion:
      'Would you prefer to work in a hospital, doctor’s office, long-term care facility, or a medical laboratory?',
    providesAnswer: 'Medical Setting',
    programs: ['PCT', 'PH', 'NA', 'MA'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Medical-Care.jpg`,
  },
  'uma-ground-03': {
    asksQuestion: '',
    providesAnswer: 'Dental Setting',
    programs: ['DA'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Dentist.jpg`,
  },
  'uma-ground-04': {
    asksQuestion: '',
    providesAnswer: 'Hospital',
    programs: ['PCT', 'PH'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/11/hospital.jpg`,
  },
  'uma-ground-05': {
    asksQuestion: '',
    providesAnswer: "Doctor's Office",
    programs: ['MA', 'NA'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/11/doctors-office.jpg`,
  },
  'uma-ground-06': {
    asksQuestion: '',
    providesAnswer: 'Long-term Care Facility',
    programs: ['PCT', 'NA'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/11/long-term-care.jpg`,
  },
  'uma-ground-07': {
    asksQuestion: '',
    providesAnswer: 'Medical Laboratory',
    programs: ['PH'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/11/medical-lab.jpg`,
  },
}

const onlineNodes = {
  'uma-online-01': {
    asksQuestion:
      'Do you care more about how something works, or just that it works?',
    providesAnswer: 'No, I cannot.',
    programs: ['HS-MAA', 'HCM', 'HHS', 'HS-PHT', 'HIM', 'MBCOA', 'HS-MOBS'],
    image: `${urls.wordpress()}/wp-content/uploads/2018/09/USA.jpg`,
  },
  'uma-online-02': {
    asksQuestion: 'Would you rather solve a math problem or a riddle?',
    providesAnswer: 'Just that it works',
    programs: ['HS-MAA', 'HCM', 'HHS', 'HS-PHT'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Sedan.jpg`,
  },
  'uma-online-03': {
    asksQuestion:
      'Do you set your clothes out the night before your workday or do you choose what you wear when you get up?',
    providesAnswer: 'A riddle',
    programs: ['HS-MAA', 'HCM', 'HHS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Question.jpg`,
  },
  'uma-online-04': {
    asksQuestion: '',
    providesAnswer: 'A math problem',
    programs: ['HS-PHT', 'HS-MAA', 'HCM'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Math.jpg`,
  },
  'uma-online-05': {
    asksQuestion: '',
    providesAnswer: 'Set out the night before',
    programs: ['HCM', 'HS-MAA', 'HHS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Night-Before.jpg`,
  },
  'uma-online-06': {
    asksQuestion: 'Are you more of a communicator or a listener?',
    providesAnswer: 'Choose when I get up',
    programs: ['HS-MAA', 'HHS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/When-You-Get-Up.jpg`,
  },
  'uma-online-07': {
    asksQuestion: '',
    providesAnswer: 'Communicator',
    programs: ['HS-MAA', 'HHS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Communicator.jpg`,
  },
  'uma-online-08': {
    asksQuestion: '',
    providesAnswer: 'Listener',
    programs: ['HHS', 'HS-MAA'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Listener.jpg`,
  },
  'uma-online-09': {
    asksQuestion: 'Do you like solving puzzles?',
    providesAnswer: 'More how it works',
    programs: ['HIM', 'MBCOA', 'HS-MOBS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Blueprint.jpg`,
  },
  'uma-online-10': {
    asksQuestion:
      'Are you detail oriented and analytical or a listener and communicator?',
    providesAnswer: 'Yes',
    programs: ['MBCOA', 'HS-MOBS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Puzzles.jpg`,
  },
  'uma-online-11': {
    asksQuestion: '',
    providesAnswer: 'No',
    programs: ['HIM', 'MBCOA', 'HS-MOBS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/No-Puzzles.jpg`,
  },
  'uma-online-12': {
    asksQuestion: '',
    providesAnswer: 'Detail oriented and analytical',
    programs: ['MBCOA', 'HS-MOBS'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Analytical.jpg`,
  },
  'uma-online-13': {
    asksQuestion: '',
    providesAnswer: 'Listener and communicator',
    programs: ['HS-MOBS', 'MBCOA'],
    image:
      `${urls.wordpress()}/wp-content/uploads/2018/09/Communicator.jpg`,
  },
}

/**
 * Object to hold ground and online quiz nodes, used for looking up nodes
 * by their id
 */
const getAllNodes = () => {
  const filteredOnlineNodes = { ...onlineNodes }

  // If IS_HCA_ENABLED is true, let's modify the nodes a bit
  // This block should be migrated to the onlineNodes object above
  // after HCA is live
  if (IS_HCA_ENABLED) {
    // Add HCA to program list of `online-02` and `online-04`
    filteredOnlineNodes['uma-online-02'] = {
      ...filteredOnlineNodes['uma-online-02'],
      programs: [
        ...filteredOnlineNodes['uma-online-02'].programs,
        'HCA',
      ],
    }

    // Add the HCA program, and configure `online-04` to ask a question
    filteredOnlineNodes['uma-online-04'] = {
      ...filteredOnlineNodes['uma-online-04'],
      asksQuestion: 'Would a career in healthcare accounting excite you?',
      programs: [
        ...filteredOnlineNodes['uma-online-04'].programs,
        'HCA',
      ],
    }

    // Inject the answers for `uma-online-4`
    filteredOnlineNodes['uma-online-14'] = {
      asksQuestion: '',
      providesAnswer: 'Yes',
      programs: ['HCA', 'HS-PHT'],
      image: `${urls.wordpress()}/wp-content/uploads/2020/07/FINAL-Interest-in-Accounting-Yes1.jpg`,
    }

    filteredOnlineNodes['uma-online-15'] = {
      asksQuestion: '',
      providesAnswer: 'No',
      programs: ['HS-PHT', 'HCA'],
      image: `${urls.wordpress()}/wp-content/uploads/2020/07/FINAL-Interest-in-Accounting-No1.jpg`,
    }
  }

  return {
    'uma-01': {
      asksQuestion:
        'Are you able to commute regularly to Downtown Clearwater, FL for class?',
      providesAnswer: '',
      image: '',
      programs: [],
    },
    ...groundNodes,
    ...filteredOnlineNodes,
  }
}

/**
 * Traverse the quiz tree structure and spread the node details found in the `allNodes` object
 * to each respective node in the `quizData.tree` object. Returns an object containing all
 * nodes key'd by id, with parent and children references. This allows us to use redux to change the
 * state to any node in the tree. Each node will be cognizant of its parent or children nodes, without
 * the app needing to maintain an object representation of the tree in state.
 *
 * @param {*} mainTree
 */
const traverse = (quizData) => {
  const nodesById = {}
  const allNodes = getAllNodes()
  const { tree, hcaTree } = quizData
  let mainTree = tree

  // If IS_HCA_ENABLED, use the `hcaTree`
  if (IS_HCA_ENABLED) {
    mainTree = hcaTree
  }

  const collectNodes = (tree, parent = null) => {
    const { children, id } = tree
    let childNodes = []
    const node = allNodes[id]

    // add the children as "shallow" objects to the
    // children array on the current node
    if (children) {
      childNodes = children.map((child) => {
        const node = allNodes[child.id]
        return {
          id: child.id,
          image: node.image,
          providesAnswer: node.providesAnswer,
        }
      })
    }

    nodesById[id] = {
      ...node,
      parent,
      children: [...childNodes],
    }

    // recursively collect nodes if children exist
    if (children) {
      children.map((child) => collectNodes(child, id))
    }
  }

  collectNodes(mainTree)

  return nodesById
}

export const quizStructure = {
  ...quizData,
  nodesById: traverse(quizData),
}
